import { render, staticRenderFns } from "./resetPwdModalForm.vue?vue&type=template&id=5395bb0c&scoped=true"
import script from "./resetPwdModalForm.vue?vue&type=script&lang=js"
export * from "./resetPwdModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395bb0c",
  null
  
)

export default component.exports